import { Injectable } from '@angular/core';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CDListPropertiesCommand } from './ck-editor-list-properties-commands';
import { DialogService } from '../dialogs/dialog.service';
import {
  BulletListType,
  ICkEditorCdListPropertiesPluginService,
  IListPropertiesModel,
  SortedListType
} from './ck-editor-cd-list-properties-plugin.interface';



@Injectable({ providedIn: 'root' })
export class CkEditorCdListPropertiesPluginService implements ICkEditorCdListPropertiesPluginService {
  currentListProperties: IListPropertiesModel = null;
  listElement: any = null;
  presetColorsPersistenceKey: string = null;

  listPropertiesMenuItemCaption: string;

  static rgbToHex(color: string) {
    color = '' + color;
    if (!color || color.indexOf('rgb') < 0) {
      return null;
    }

    if (color.charAt(0) === '#') {
      return color;
    }

    var nums = /(.*?)rgb\((\d+),\s*(\d+),\s*(\d+)\)/i.exec(color),
      r = parseInt(nums[2], 10).toString(16),
      g = parseInt(nums[3], 10).toString(16),
      b = parseInt(nums[4], 10).toString(16);

    return '#' + (
      (r.length === 1 ? '0' + r : r) +
      (g.length === 1 ? '0' + g : g) +
      (b.length === 1 ? '0' + b : b)
    );
  }

  constructor(private dialogService: DialogService, public zone: NgZone, private translate: TranslateService) {
    this.listPropertiesMenuItemCaption = translate.instant('COMMON.DIALOGS.LIST_PROPERTIES.CK_MENUITEM_TITLE');

    CKEDITOR.plugins.add('cdlistproperties', this);
  }

  convertCssStyleToFamilySelectorModel(cssFontFamilyValue: string) {
    let result = cssFontFamilyValue.replace(/\"/g, '');
    result = result.replace(/, /g, ',');
    return result;
  }

  init(editor: any) {
    editor.addCommand('cdListProperties', new CDListPropertiesCommand(this.dialogService, this));

    if (editor.addMenuItems) {
      editor.addMenuGroup('clickDimensionsMenuListPropertiesGroup');
      editor.addMenuItems({
        cdOrderedListPropertiesMenuItem: {
          order: null,
          label: this.listPropertiesMenuItemCaption,
          group: 'clickDimensionsMenuListPropertiesGroup',
          command: 'cdListProperties',
          icon: `/assets/images/ordered_list.png`
        },

        cdUnorderedListPropertiesMenuItem: {
          order: null,
          label: this.listPropertiesMenuItemCaption,
          group: 'clickDimensionsMenuListPropertiesGroup',
          command: 'cdListProperties',
          icon: `/assets/images/unordered_list.png`
        }
      });
    }

    // If the "contextmenu" plugin is loaded, register the listeners.
    if (editor.contextMenu) {
      editor.contextMenu.addListener((element: CKEDITOR.dom.element, selection: CKEDITOR.dom.selection, path: CKEDITOR.dom.elementPath) => {

        if (!element || element.isReadOnly())
          return null;

        let el: HTMLElement;
        while (element) {
          let name = element.getName();
          if (name === 'ol' || name === 'ul') {
            el = element.$;
            this.listElement = el;

            // instantiate a new instance for the currently selected element throwing the old one to GC
            let currentListProperties: IListPropertiesModel = this.currentListProperties = {
              isOrderedList: (name === 'ol')
            };

            if (currentListProperties.isOrderedList) {
              let startAttribute = el.getAttribute('start');
              if (startAttribute) {
                currentListProperties.startFrom = parseInt(startAttribute);
              } else {
                currentListProperties.startFrom = 1;
              }

              if (el.style.listStyleType) {
                currentListProperties.orderedListType = <SortedListType>el.style.listStyleType;
              }
            }

            if (!currentListProperties.isOrderedList) {
              if (el.style.listStyleType) {
                currentListProperties.bulletType = <BulletListType>el.style.listStyleType;
              }
            }

            //add the properties that exits if there are such so they can be edited
            if (el.style.color) {
              currentListProperties.color = CkEditorCdListPropertiesPluginService.rgbToHex(el.style.color);
            }

            if (el.style.fontFamily) {
              currentListProperties.fontFamily = this.convertCssStyleToFamilySelectorModel(el.style.fontFamily);
            }

            if (el.style.fontSize) {
              currentListProperties.fontSize = el.style.fontSize;
            }

            if (el.style.fontWeight) {
              currentListProperties.isBold = (el.style.fontWeight === 'bold');
            }

            if (el.style.fontStyle) {
              currentListProperties.isItalic = (el.style.fontStyle === 'italic');
            }


            if (name === 'ol') {
              return { cdOrderedListPropertiesMenuItem: editor.CKEDITOR.TRISTATE_OFF };
            }

            if (name === 'ul') {
              return { cdUnorderedListPropertiesMenuItem: editor.CKEDITOR.TRISTATE_OFF };
            }
          }
          element = element.getParent();
        }
        return null;
      });
    }
  }
}
